@if (isScreenTooSmall()) {
<app-screen-too-small
    [titleText]="'general.screen-too-small.title' | translate"
    [descriptionText]="'general.screen-too-small.description' | translate"
></app-screen-too-small>
}

<button
    class="absolute top-[-40px] left-[235px] bg-[var(--actionColor)] text-[#00183b] px-3 py-1 z-[1000] border-2 border-transparent focus:top-0 focus:border-[#00183b] transition-all"
    [attr.aria-label]="'general.bypass-link.skip-to-content' | translate"
    (click)="onSkipLinkClick($event)"
>
    <span class="icon-chevron-right pr-1"></span>
    <span>{{ 'general.bypass-link.skip-to-content' | translate }}</span>
</button>

<div class="page-wrapper h-full" [class.hidden]="isScreenTooSmall()">
    <app-header [wasScrolled]="wasScrolled"></app-header>
    <div class="content-wrapper grow w-full relative">
        <router-outlet> </router-outlet>
    </div>
    <div class="-rotate-90 origin-bottom-right fixed z-2 right-0 top-1/3">
        <sag-ui-button (click)="openHelpDeskDialog()">
            <div class="flex gap-4 p-1">
                <span class="material-symbols-outlined text-xl text-black" aria-hidden="true"> chat_bubble </span>
                <span>{{ 'home.helpButton' | translate }}</span>
            </div>
        </sag-ui-button>
    </div>

    <app-footer> </app-footer>
</div>
